export class UserPermission {
  private userPermissionKey: string;
  private name: string;
  private code: string;
  private userRoleType: string;

  setUserPermissionKey(value: string): void {
    this.userPermissionKey = value;
  }

  getUserPermissionKey(): string {
    return this.userPermissionKey;
  }

  setName(value: string): void {
    this.name = value;
  }

  getName(): string {
    return this.name;
  }

  setCode(value: string): void {
    this.code = value;
  }

  getCode(): string {
    return this.code;
  }

  setUserRoleType(value: string): void {
    this.userRoleType = value;
  }

  getUserRoleType(): string {
    return this.userRoleType;
  }
}
